import { PasswordFormModal } from "components/settings/user/form/passwordForm";
import { get } from "lodash";
import PropTypes from "prop-types"; 
import React from "react";
import { connect } from "react-redux";

function ProfileChangePassword({ onClose, userId }) {
    return <PasswordFormModal id={userId} onClose={onClose} />;
}

ProfileChangePassword.propTypes = {
    onClose: PropTypes.func.isRequired,
    userId: PropTypes.number.isRequired,
};

export default connect((state) => {
    return {
        userId: get(state.login.user, "id", null),
    };
})(ProfileChangePassword);
